var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.id}},[_c(_vm.compMetadata.type,{tag:"component",attrs:{"id":_vm.compMetadata.id,"config":_vm.compMetadata.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }